export default "__VITE_ASSET__CkN3WOpy__"